export const queryKeys = Object.freeze({
  addNoteReply: 'add-note-replies',
  assessments: 'assessments',
  attachment: 'attachment',
  backlog: 'backlog',
  mySprints: 'my-sprints',
  sprints: 'sprints',
  draftSprints: 'draft-sprints',
  participants: 'participants',
  controlCenterParticipants: 'control-center-participants',
  participant: 'participant',
  morpheusInsights: 'morpheus-insights',
  morpheusParticipant: 'morpheus-participant',
  hdeMission: 'hde-mission',
  user: 'user',
  challenges: 'challenges',
  challengeGoals: 'challenge-goals',
  libraryChallenges: 'library-challenges',
  connections: 'connections',
  dimensions: 'dimensions',
  sharedSprints: 'shared-sprints',
  challengeNotes: 'challenge-notes',
  users: 'users',
  coaches: 'coaches',
  coachingTools: 'coaching-tools',
  chatMessages: 'chats-messages',
  chatMessagesHistory: 'chats-messages-history',
  chats: 'chats',
  coachProfile: 'coach-profile',
  coachSessions: 'coach-sessions',
  coachingSessionPrepInfo: 'coaching-session-prep-info',
  quickStartSprint: 'quick-start-sprint',
  quickStartSprints: 'quick-start-sprints',
  coachingSessionPrepInsights: 'coaching-session-prep-insights',
  goals: 'goals',
  goal: 'goal',
  goalBreakdown: 'goal-breakdown',
  reflection: 'reflection',
  statistic: 'statistic',
  participantsSprints: 'participants-sprints',
  noteReplies: 'note-replies',
  scheduledMessages: 'scheduled-messages',
  version: 'version',
  challengeTargetUnits: 'challenge-target-units',
  coachingTimezones: 'coaching-timezones',
  file: 'file',
  momentum: 'momentum',
  myGroups: 'my-groups',
  participantSessions: 'participant-sessions',
  resourceBank: 'resource-bank',
  coachSession: 'coach-session',
  coachSessionTranscript: 'coach-session-transcript',
  coachSessionTranscriptCustomStructure:
    'coach-session-transcript-custom-structure',
  coachSessionMetadata: 'coach-session-metadata',
  coach: 'coach',
  history: 'history',
  linkPreview: 'link-preview',
  journal: 'journal',
  subAccounts: 'sub-accounts',
  tasks: 'tasks',
  cortexChat: 'cortex-chat',
  objectives: 'objectives',
});

export const HTTP_ERROR_STATUS_CODES = {
  UNAUTHORIZED: '401',
  FORBIDDEN: '403',
  NOT_FOUND: '404',
  INTERNAL_ERROR: '500',
  BAD_GATEWAY: '502',
  SERVICE_UNAVAILABLE: '503',
  GATEWAY_TIMEOUT: '504',
};

export const RETRYABLE_STATUS_CODES = [
  HTTP_ERROR_STATUS_CODES.INTERNAL_ERROR,
  HTTP_ERROR_STATUS_CODES.BAD_GATEWAY,
  HTTP_ERROR_STATUS_CODES.SERVICE_UNAVAILABLE,
  HTTP_ERROR_STATUS_CODES.GATEWAY_TIMEOUT,
];

export const DEFAULT_RETRY_COUNT = 3;

export const API_VERSION = '16';

// relates to sub accounts
export const HOS_SUB_ACCOUNT_USER_ID = 'hos-sub-acc-user-id';
export const HOS_SUB_ACCOUNT_GROUP_ID = 'hos-sub-acc-group-id';
